module.exports = __webpack_public_path__ + "static/media/limogesflorist.95487b4c.png";